import { Component, OnInit } from '@angular/core';

import { UtenteService } from '@app/shared/services/utente.service';

@Component({
  selector: 'info-utente',
  templateUrl: './info-utente.component.html',
  styleUrls: ['./info-utente.component.scss']
})
export class InfoUtenteComponent implements OnInit {

  utente: any;

  constructor(private utenteService: UtenteService) {
   
  }

  ngOnInit(): void {

    this.utenteService.getCurrentUser().subscribe(utente => { 
      this.utente = utente;
    })

  }

}
